import { render, staticRenderFns } from "./RetentionCategoryInput.vue?vue&type=template&id=43731a62&"
import script from "./RetentionCategoryInput.vue?vue&type=script&lang=js&"
export * from "./RetentionCategoryInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports